import { createFileRoute } from '@tanstack/react-router';
import { checkAnalyticsSecurityDomain } from '../../components/analytics/utils/routeGuards';
import AnalyticsPageLayout from '../../components/analytics/shared/AnalyticsPageLayout';
import { getCategoryById } from '../../components/analytics/config';
import UtilizationDashboard from '../../components/analytics/utilization/UtilizationDashboard';
import { useAnalyticsFilters } from '../../components/analytics/filters';

export const Route = createFileRoute('/team-insights/utilization')({
  component: RouteComponent,
  beforeLoad: checkAnalyticsSecurityDomain({
    routeObject: 'analytics',
  }),
});

function RouteComponent() {
  const { filters, updateFilters } = useAnalyticsFilters();
  const category = getCategoryById('utilization');

  if (!category) {
    return <div>Category not found</div>;
  }

  return (
    <AnalyticsPageLayout category={category} filters={filters} onFiltersChange={updateFilters}>
      <UtilizationDashboard filters={filters} />
    </AnalyticsPageLayout>
  );
}
